<template>
    <li class="goods-item">
        <img :src="cover" alt="商品" class="goods-img">
        <div class="goods-info">
            <img src="../images/coin.png" alt="金币" class="goods-coin">
            {{ price }}
        </div>
    </li>
</template>

<script>
export default {
    name: 'GoodsItem',
    props: {
        cover: {
            type: String,
            default: '',
        },
        price: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style scoped>
.goods-item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 12px 0 12px;
    width: 23%;
    margin: 0 1% 16px;
    background: url(../images/goods-bg.png) center/100% 100% no-repeat ;
    border-radius: 23px;
}
.goods-img {
    width: 158px;
    height: 170px;
    object-fit: cover;
    border-radius: 30px;
}
.goods-info {
    display: flex;
    align-items: center;
    padding: 4px 16px 12px;
    font-size: 28px;
    font-weight: bold;
    color: #EA921D;
}
.goods-coin {
    width: 42px;
    height: 42px;
    margin-right: 20px;
}
</style>